var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 15.9453L9.08333 10.6953C8.66667 11.0286 8.1875 11.2925 7.64583 11.487C7.10417 11.6814 6.52778 11.7786 5.91667 11.7786C4.40278 11.7786 3.12153 11.2543 2.07292 10.2057C1.02431 9.15712 0.5 7.87587 0.5 6.36198C0.5 4.84809 1.02431 3.56684 2.07292 2.51823C3.12153 1.46962 4.40278 0.945312 5.91667 0.945312C7.43056 0.945312 8.71181 1.46962 9.76042 2.51823C10.809 3.56684 11.3333 4.84809 11.3333 6.36198C11.3333 6.97309 11.2361 7.54948 11.0417 8.09115C10.8472 8.63281 10.5833 9.11198 10.25 9.52865L15.5 14.7786L14.3333 15.9453ZM5.91667 10.112C6.95833 10.112 7.84375 9.7474 8.57292 9.01823C9.30208 8.28906 9.66667 7.40365 9.66667 6.36198C9.66667 5.32031 9.30208 4.4349 8.57292 3.70573C7.84375 2.97656 6.95833 2.61198 5.91667 2.61198C4.875 2.61198 3.98958 2.97656 3.26042 3.70573C2.53125 4.4349 2.16667 5.32031 2.16667 6.36198C2.16667 7.40365 2.53125 8.28906 3.26042 9.01823C3.98958 9.7474 4.875 10.112 5.91667 10.112Z",
    fill: "#A100FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.2eab26fc00bd9147b4560478f7dad586.svg";
export { ForwardRef as ReactComponent };